import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

// Set Telegram safe-area offset so app content doesn't hide under native chrome
;(function setTgSafeArea() {
  const tg = (window as any).Telegram?.WebApp
  if (!tg) return
  const sys = tg.safeAreaInset?.top ?? 0
  const app = tg.contentSafeAreaInset?.top ?? 0
  const total = sys + app
  if (total > 0) {
    document.documentElement.style.setProperty('--tg-app-top', `${total}px`)
  }
})()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#1A2740',
            color: '#F4F1EA',
            borderRadius: '12px',
            border: '1px solid rgba(244,238,225,0.14)',
            fontSize: '13px',
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
)
